import React from 'react';
import { Table } from 'react-bootstrap';
import { AiOutlineCopy } from 'react-icons/ai';

const CertificateMintDetail = ({ certificateDetails }) => {
  // console.log(certificateDetails)

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    alert("Copied!");
  };


  return (
    <div className='container  py-5 text-light'>
      <div>
        <h5 style={{ color: "white" }}>HOW TO IMPORT NFT ON METAMASK?</h5>
        <p> In MetaMask Mobile, tap on the 'NFTs' tab, scroll down and tap on the 'Import NFTs' link. Paste the NFT's Contact address from your clipboard into the 'Address' box. Find the NFT's ID. A collectible's Token Id is a unique identifier since no two NFTs are alike.</p>
      </div>
      <div className="py-2">
        <div className="tableNormal ">
          <Table>
            <thead className='text-light'>
              <tr>
                <th className="text-left">Contact Address</th>
                <th className="text-left">Token Id</th>
                <th className="text-left ">Date</th>
                <th className="text-left"> Transaction</th>
              </tr>
            </thead>
            <tbody>
              <tr className="tableRow" >
                <td className="text-left text-light">
                  <span className='d-flex'>
                    {certificateDetails?.contactAdd}

                    <AiOutlineCopy
                      onClick={() => copyToClipboard(certificateDetails?.contactAdd)} className='bg-primary ms-1 p-1 fs-3 text-light'
                      style={{ fontSize: "20px", cursor: 'pointer' }} />
                  </span>
                  <span></span>
                </td>

                <td className="text-left text-light">
                  <span className='d-flex'>
                    {certificateDetails?.tokenId}
                    <AiOutlineCopy
                      onClick={() => copyToClipboard(certificateDetails?.tokenId)}
                      className='bg-primary ms-1 p-1 fs-3 text-light '
                      style={{ fontSize: "20px", cursor: 'pointer' }} />
                  </span>
                </td>

                <td className="text-left text-light">
                  {certificateDetails?.date}

                </td>

                <td className="text-left text-light text-decoration-underline">
                  <a href={certificateDetails?.minthast} target="_blank" rel="noopener noreferrer">Click Here</a>
                </td>

              </tr>
            </tbody>
          </Table>
        </div>
      </div>
    </div>
  )
}

export default CertificateMintDetail